// Format: { partnerId: [storeConfigId, ...], ... }
export const enabledStoreConfigurationIds: Record<number, number[]> = {
  1: [
    1266, // https://shop.biritemarket.com
  ],

  289: [
    1177, // https://freshgrocery.instacart.com
  ],

  295: [
    1249, // https://shop.metropolitan-market.com
  ],

  304: [
    1672, // https://shop.aldi.us
  ],

  353: [
    1221, // https://shopnow.stewleonards.com
  ],

  370: [
    1250, // https://shop.pricechopper.com
  ],

  381: [
    1246, // https://shop.newseasonsmarket.com
    1247, // https://shop.newleaf.com
  ],

  382: [
    1216, // https://shop.sprouts.com
  ],

  484: [
    1431, // https://member.restaurantdepot.com
  ],

  517: [
    1381, // https://foodtown-whitelabel.instacart.com
    1417, // https://brooklynharvest-whitelabel.instacart.com
    1418, // https://shop.greenwaymarkets.com
    1420, // https://pathmark-whitelabel.instacart.com
    1422, // https://shop.marrazzosmarket.com
    1423, // https://brigidos-whitelabel.instacart.com
    1432, // https://labellamarkets-whitelabel.instacart.com
    1433, // https://marketfresh-whitelabel.instacart.com
    1557, // https://freshtown-whitelabel.instacart.com
    1558, // https://pecksmarket-whitelabel.instacart.com
  ],

  567: [
    1419, // https://mortonwilliams-whitelabel.instacart.com
  ],

  573: [
    134, // https://shop.hornbachers.com
    1260, // https://shop.coborns.com
    1261, // https://shop.shopmarketplacefoods.com
    1262, // https://shop.cashwise.com
    1331, // https://shop.andysliquor.com
  ],

  596: [
    1217, // https://shop.thefreshmarket.com
  ],

  613: [
    1209, // https://shop.foodbazaar.com
  ],

  639: [
    1605, // https://order.shopthepig.com
  ],

  711: [
    1478, // https://gristedes-whitelabel.instacart.com
  ],

  885: [
    1245, // https://shop.bristolfarms.com
    1248, // https://shop.lazyacres.com
  ],

  2209: [
    1560,
    1561, // https://shop.cardenasmarkets.com
    1562, // https://shop.elranchoinc.com
    1563, // https://shop.tonysfreshmarket.com
  ],

  2250: [
    1205, // https://shopwoodmans.com
  ],

  2265: [
    1275, // https://staging-shop.sprouts.com
  ],

  2601: [
    1436, // https://shop.littlegiantfarmersmarket.com
  ],

  5343: [
    1350, // https://shop.rosauers.com
    1354, // https://super1foods-whitelabel.instacart.com
    1356, // https://shop.huckleberrysnaturalmarket.com
  ],

  5790: [
    1403, // https://shop.freshmarketstores.com
  ],

  7571: [
    1556, // https://beta-shop.yokesfreshmarkets.com
  ],

  7728: [
    1445, // https://shop.davisfoodanddrug.com
  ],

  7730: [
    1577, // https://shop.geisslers.com
  ],

  8013: [
    1576, // https://shop.cropsmarketplace.com
  ],

  8119: [
    1574, // https://shopfoods.skh.com
  ],

  8485: [
    1258, // https://shop.harmonsgrocery.com
  ],

  9366: [
    1347, // https://shop.harristeeterbymarianos-dev.com
    1348, // https://shop.qfc-dev.com
    1349, // https://shop.marianos-dev.com
  ],

  10010: [
    1495, // https://shop.freshtakegrocery.com
  ],

  10265: [
    1666, // https://dierbergsmarkets-whitelabel.instacart.com
  ],

  10467: [
    1469, // https://dagostino-whitelabel.instacart.com
  ],
}
